import * as React from "react";
const SvgDeleteW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.3 2.888a61 61 0 0 0-6.012-.3q-1.782 0-3.564.18L.5 2.888m3.3-.606.132-.786C4.028.926 4.1.5 5.114.5h1.572C7.7.5 7.778.95 7.868 1.502l.132.78m2.01 2.502-.39 6.042c-.066.942-.12 1.674-1.794 1.674H3.974c-1.674 0-1.728-.732-1.794-1.674l-.39-6.042M4.898 9.2h1.998M4.4 6.8h3"
    />
  </svg>
);
export default SvgDeleteW;
